import { ConsoleProvider } from './ConsoleProvider';
import { GtmProvider } from './GtmProvider';
import type { AnalyticsProvider, AnalyticsProviderType } from '../types';

type ProviderFactory = (gtmContainerId: string) => AnalyticsProvider;

const PROVIDER_FACTORIES: Record<AnalyticsProviderType, ProviderFactory> = {
    gtm: (gtmContainerId) => new GtmProvider(gtmContainerId),
    console: () => new ConsoleProvider(),
};

/** Creates a real (configurable) provider. Callers use NoopProvider when disabled. */
export function createProvider(
    type: AnalyticsProviderType,
    gtmContainerId: string
): AnalyticsProvider {
    return PROVIDER_FACTORIES[type](gtmContainerId);
}
